import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    service: undefined,
    model: undefined,
    starts: undefined,
    stops: undefined,
};
const pricesSlice = createSlice({
    name: "prices",
    initialState,
    reducers: {
        setService(state, action) {
            state.service = action.payload;
        },
        setModel(state, action) {
            state.model = action.payload;
        },
        setStarts(state, action) {
            state.starts = action.payload;
        },
        setStops(state, action) {
            state.stops = action.payload;
        },
    },
});
export const { setService, setModel, setStarts, setStops } = pricesSlice.actions;
export default pricesSlice.reducer;
export const pricesSelector = (state) => state.prices;
